import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import { CODE_ERRORS, ENDPOINT_API_PATH } from '../Definitions/MemberDef';

const autoGenerateSuccess = () => {
  const validateDocumentSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        ...MocksDef.MEMBER_CREATE,
      },
    },
    configResponse: {
      status: 200,
      data: {
        member: MocksDef.MEMBER_CREATE,
      },
      headers: {},
    },
  };
  return validateDocumentSuccess;
};

const autoGenerateSuccessToken = autoGenerateSuccess();

const generatedSuccessMocks = [autoGenerateSuccessToken];

const autoGenerate = () => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const validaMember = {
        ...MocksDef.MEMBER_CREATE,
        name: `${MocksDef.NAME}-${index}`,
      };
      const body = {
        ...validaMember,
      };
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body,
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseError = autoGenerate();
  return [...responseError];
};

const errorsGenerated = autoGenerateErrorsMock();

const CreateMember = [...generatedSuccessMocks, ...errorsGenerated];
export default CreateMember;
